import './skeleton.css';

export type SkeletonVariant =
  'rows' | 'facts' | 'calendar' | 'document' | 'person' | 'notebook' | 'stamps';

/**
 * Esqueleto de carregamento no formato do conteúdo que vai chegar. Só aparece
 * se a espera passar de 150 ms (resposta rápida não pisca) e o brilho para
 * com movimento reduzido no sistema.
 */
export function Skeleton({
  variant = 'rows',
  label = 'Carregando',
}: {
  variant?: SkeletonVariant;
  label?: string;
}) {
  return (
    <div className={`sk sk-${variant}`} role="status" aria-label={label}>
      {variant === 'rows' && (
        <>
          <Row />
          <Row />
          <Row short />
        </>
      )}
      {variant === 'facts' && (
        <>
          <div className="sk-facts-top">
            <i className="sk-b sk-big" />
            <i className="sk-b sk-ring" />
          </div>
          <Row />
          <Row short />
        </>
      )}
      {variant === 'calendar' && (
        <>
          <div className="sk-days">
            {Array.from({ length: 7 }, (_, index) => (
              <i key={index} className="sk-b sk-day" />
            ))}
          </div>
          <Row time />
          <Row time />
          <Row time short />
        </>
      )}
      {variant === 'document' && (
        <>
          <Row doc />
          <Row doc />
          <Row doc short />
        </>
      )}
      {variant === 'person' && (
        <>
          <Row avatar />
          <Row avatar />
          <Row avatar short />
          <Row avatar />
        </>
      )}
      {variant === 'notebook' && (
        <>
          <Area />
          <Area short />
        </>
      )}
      {variant === 'stamps' && (
        <>
          <div className="sk-pass">
            <div className="sk-pass-top">
              <i className="sk-b sk-line sk-w45" />
              <i className="sk-b sk-pill" />
            </div>
            <div className="sk-stamp-row">
              {Array.from({ length: 7 }, (_, index) => (
                <i key={index} className="sk-b sk-stamp" />
              ))}
            </div>
          </div>
          <Row avatar />
          <Row avatar short />
        </>
      )}
    </div>
  );
}

/** Uma área do Caderno: ícone, nome e as lembranças dela. */
function Area({ short = false }: { short?: boolean }) {
  return (
    <div className="sk-area">
      <div className="sk-area-hd">
        <i className="sk-b sk-ic" />
        <i className="sk-b sk-line sk-w30" />
      </div>
      <span className="sk-lines">
        <i className="sk-b sk-line sk-thin sk-w30" />
        <i className={`sk-b sk-line${short ? ' sk-w45' : ' sk-w70'}`} />
      </span>
      {!short && (
        <span className="sk-lines">
          <i className="sk-b sk-line sk-thin sk-w45" />
          <i className="sk-b sk-line sk-w50" />
        </span>
      )}
    </div>
  );
}

function Row({
  short = false,
  time = false,
  doc = false,
  avatar = false,
}: {
  short?: boolean;
  time?: boolean;
  doc?: boolean;
  avatar?: boolean;
}) {
  return (
    <div className="sk-row">
      {time && <i className="sk-b sk-time" />}
      {doc && <i className="sk-b sk-doc" />}
      {avatar && <i className="sk-b sk-av" />}
      <span className="sk-lines">
        <i className={`sk-b sk-line${short ? ' sk-w50' : ' sk-w70'}`} />
        <i className={`sk-b sk-line sk-thin${short ? ' sk-w30' : ' sk-w45'}`} />
      </span>
    </div>
  );
}
